/**
 * @generated SignedSource<<2f8da830818c3b5fc325718ec60c1ecb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespFollowSearchBanner_user" | "SbRespInteriorsWordpressArticlesWrapper_user" | "SbRespMainContent_user" | "SbRespNullSearchResults_user" | "SharedFollowSearchProvider_user" | "SharedFollowTopButton_user" | "SharedRecentSales_user" | "SharedYMAL_user" | "TradePromo_user">;
  readonly " $fragmentType": "SbRespComponents_user";
};
export type SbRespComponents_user$key = {
  readonly " $data"?: SbRespComponents_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespComponents_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradePromo_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowSearchProvider_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsWordpressArticlesWrapper_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedYMAL_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d0680193f8eb4cee42f43b40083b27d1";

export default node;
